/*** IMPORTS FROM imports-loader ***/
var define = false;

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import $ from 'jquery';
require('../vendor/magnific.js');

export function heroReel() {
  let reelContainer = document.querySelector('.reel__reelContainer');
  let videoElem = document.querySelector(".reel__bRoll");
  let videoFull = document.getElementById("reel__fullVideo");
  let playButton = document.querySelector(".playPauseVideo");

  playButton.addEventListener("click", handlePlayButton, false);
  // playVideo();

  // autoplya broll
  async function playVideo() {
    try {
      await videoElem.play();
      playButton.classList.add("playPauseVideo--playing");
    } catch (err) {
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // Play full Video
  async function playFullVideo() {
    try {
      await videoFull.play();
    } catch (err) {
      // error
    }
  }

  function handlePlayButton() {

    if (videoElem.paused) {
      playVideo();
    } else {
      videoElem.pause();
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // pause video on esc
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      handlePlayButton();
    }
  };

  // Play full video on click
  reelContainer.addEventListener('click', function () {
    if (reelContainer.classList.contains('reel--playing')) {
      // alert('it is playing');
      videoFull.pause();
      reelContainer.classList.remove('reel--playing');
      // adding this class allows us to animate everything with css
      document.querySelector('body').classList.toggle('playing-project-video');
    } else {
      // alert('it was not playing');
      playFullVideo();
      reelContainer.classList.add('reel--playing');
      document.querySelector('body').classList.toggle('playing-project-video');
    }
  });

  gsap.to(".reel__reelContainer", {
    clipPath: "inset(0px round 30px)",
    webkitClipPath: "inset(0px round 30px)",  // for Safari
    ease: "none",
    scrollTrigger: {
      trigger: ".reel__reelContainer",
      start: "top bottom",
      end: "top 50%",
      scrub: true,
      // markers: true
    }
  });

  gsap.to('.reel__reelContainer', {
    scrollTrigger: {
      trigger: '.reel__reelContainer',
      start: 'top 70%',
      // markers: true,
      onEnter: function () {
        playVideo();
      },
      onLeave: function () {
        videoElem.pause();
        playButton.classList.remove("playPauseVideo--playing");
        reelContainer.classList.remove('reel--playing');
        videoFull.pause();
        document.querySelector('body').classList.remove('playing-project-video');
      },
      onEnterBack: function () {
        videoElem.play();
      },
      onLeaveBack: function () {
        videoElem.pause();
        playButton.classList.remove("playPauseVideo--playing");
        reelContainer.classList.remove('reel--playing');
        videoFull.pause();
        document.querySelector('body').classList.remove('playing-project-video');
      }
    }
  });

}

export function howReel() {
  let reelContainer = document.querySelector('.how__reelContainer');
  let videoElem = document.getElementById("how__bRoll");
  let videoFull = document.getElementById("how__fullVideo");
  let playButton = document.querySelector(".playPauseVideo");

  playButton.addEventListener("click", handlePlayButton, false);
  // playVideo();

  // autoplya broll
  async function playVideo() {
    try {
      await videoElem.play();
      playButton.classList.add("playPauseVideo--playing");
    } catch (err) {
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // Play full Video
  async function playFullVideo() {
    try {
      await videoFull.play();
    } catch (err) {
      // error
    }
  }

  function handlePlayButton() {

    if (videoElem.paused) {
      playVideo();
    } else {
      videoElem.pause();
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // pause video on esc
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      handlePlayButton();
    }
  };

  // Play full video on click
  reelContainer.addEventListener('click', function () {
    if (reelContainer.classList.contains('reel--playing')) {
      // alert('it is playing');
      videoFull.pause();
      reelContainer.classList.remove('reel--playing');
      // adding this class allows us to animate everything with css
      document.querySelector('body').classList.toggle('playing-project-video');
    } else {
      // alert('it was not playing');
      playFullVideo();
      reelContainer.classList.add('reel--playing');
      document.querySelector('body').classList.toggle('playing-project-video');
    }
  });

  // gsap.to(".how__reelContainer", {
  //   clipPath: "inset(0px round 30px)",
  //   webkitClipPath: "inset(0px round 30px)",  // for Safari
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".how__reelContainer",
  //     start: "top bottom",
  //     end: "top 50%",
  //     scrub: true,
  //     scroller: '.fullView',
  //     // markers: true
  //   }
  // });

  gsap.to('.how__reelContainer', {
    scrollTrigger: {
      trigger: '.how',
      start: 'top 70%',
      scroller: '.fullView',
      // markers: true,
      onEnter: function () {
        playVideo();
      },
      onLeave: function () {
        videoElem.pause();
        playButton.classList.remove("playPauseVideo--playing");
        reelContainer.classList.remove('reel--playing');
        videoFull.pause();
        document.querySelector('body').classList.remove('playing-project-video');
      },
      onEnterBack: function () {
        videoElem.play();
      },
      onLeaveBack: function () {
        videoElem.pause();
        playButton.classList.remove("playPauseVideo--playing");
        reelContainer.classList.remove('reel--playing');
        videoFull.pause();
        document.querySelector('body').classList.remove('playing-project-video');
      }
    }
  });

}

export function caseStudyReel() {
  let reelContainer = document.querySelector('.caseStudy__reelContainer');
  let videoElem = document.getElementById("caseStudy__bRoll");
  let videoFull = document.getElementById("caseStudy__fullVideo");
  let playButton = document.querySelector(".playPauseVideo");

  playButton.addEventListener("click", handlePlayButton, false);
  // playVideo();

  // autoplya broll
  async function playVideo() {
    try {
      await videoElem.play();
      playButton.classList.add("playPauseVideo--playing");
    } catch (err) {
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // Play full Video
  async function playFullVideo() {
    try {
      await videoFull.play();
    } catch (err) {
      // error
    }
  }

  function handlePlayButton() {

    if (videoElem.paused) {
      playVideo();
    } else {
      videoElem.pause();
      playButton.classList.remove("playPauseVideo--playing");
    }
  }

  // pause video on esc
  document.onkeydown = function (evt) {
    evt = evt || window.event;
    if (evt.keyCode == 27) {
      handlePlayButton();
    }
  };

  // Play full video on click
  reelContainer.addEventListener('click', function () {
    if (reelContainer.classList.contains('reel--playing')) {
      // alert('it is playing');
      videoFull.pause();
      reelContainer.classList.remove('reel--playing');
      // adding this class allows us to animate everything with css
      document.querySelector('body').classList.toggle('playing-project-video');
    } else {
      // alert('it was not playing');
      playFullVideo();
      reelContainer.classList.add('reel--playing');
      document.querySelector('body').classList.toggle('playing-project-video');
    }
  });

  // gsap.to(".how__reelContainer", {
  //   clipPath: "inset(0px round 30px)",
  //   webkitClipPath: "inset(0px round 30px)",  // for Safari
  //   ease: "none",
  //   scrollTrigger: {
  //     trigger: ".how__reelContainer",
  //     start: "top bottom",
  //     end: "top 50%",
  //     scrub: true,
  //     scroller: '.fullView',
  //     // markers: true
  //   }
  // });

  gsap.to('.caseStudy__reelContainer', {
    scrollTrigger: {
      trigger: '.reelContainer',
      start: 'top 70%',
      // markers: true,
      onEnter: function () {
        playVideo();
      },
      onLeave: function () {
        videoElem.pause();
        playButton.classList.remove("playPauseVideo--playing");
        reelContainer.classList.remove('reel--playing');
        videoFull.pause();
        document.querySelector('body').classList.remove('playing-project-video');
      },
      onEnterBack: function () {
        videoElem.play();
      },
      onLeaveBack: function () {
        videoElem.pause();
        playButton.classList.remove("playPauseVideo--playing");
        reelContainer.classList.remove('reel--playing');
        videoFull.pause();
        document.querySelector('body').classList.remove('playing-project-video');
      }
    }
  });

}
